// @flow

import type { SearchNotification } from './types';

export function replaceSearchNotification(
  searchNotifications: SearchNotification<*>[],
  newSearchNotification: SearchNotification<*>
): SearchNotification<*>[] {
  const searchNotificationIndex = searchNotifications.findIndex(
    searchNotification => searchNotification.id === newSearchNotification.id
  );

  if (searchNotificationIndex === -1) {
    return searchNotifications;
  }

  const newSearchNotifications = [...searchNotifications];
  newSearchNotifications[searchNotificationIndex] = newSearchNotification;
  return newSearchNotifications;
}

export function removeSearchNotification(
  searchNotifications: SearchNotification<*>[],
  oldSearchNotification: SearchNotification<*>
): SearchNotification<*>[] {
  return searchNotifications.filter(
    searchNotification => searchNotification.id !== oldSearchNotification.id
  );
}

export function updateChangeStatus(
  searchNotifications: SearchNotification<*>[],
  newSearchNotification: SearchNotification<*>
): SearchNotification<*> {
  const foundSearchNotification = searchNotifications.find(
    searchNotification => newSearchNotification.id === searchNotification.id
  );

  if (!foundSearchNotification) {
    return newSearchNotification;
  }

  return {
    ...newSearchNotification,
    changed: foundSearchNotification.active !== newSearchNotification.active,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/utils.js